import { ReactComponent as Loading } from './loading.svg';
import { ReactComponent as NotFound } from './not-found.svg';
import { ReactComponent as Close } from './close.svg';
import { ReactComponent as Search } from './search.svg';
import { ReactComponent as DownArrow } from './arrow.svg';
import { ReactComponent as UpArrow } from './up-arrow.svg';
export { Loading, NotFound, Search, DownArrow, UpArrow, Close };
